import client from "../client";

const getBookings = (location: string) =>
  client.get<any>(`/bookings/${location}`);

const getBookingsForClients = (location: string) =>
  client.get<any>(`/bookings-for-clients/${location}`);

const book = (props: any, location: string) =>
  client.post<any>(`/bookings/${location}`, props);

const cancel = (props: any) => client.post<any>(`/bookings/cancel/${props.id}`);

const trainerCancel = (props: any) =>
  client.post<any>(`/bookings/trainer/cancel/${props.id}`, {
    expectedClients: props.expectedClients,
  });

const trainerBook = (props: any) =>
  client.post<any>(`/bookings/trainer/book/${props.id}`);

const bookAll = (props: any, location: string, id: number) =>
  client.post<any>(`/bookings/all/${id}/${location}`, props);

const cancelByClientId = (props: any, clientId: number) =>
  client.post<any>(`/bookings/cancel/${props.id}/${clientId}`);

const setTrainer = (id: number, trainerId: number | null) =>
  client.post<any>(`/bookings/set-trainer/${id}`, { trainerId });

const getCancellations = (params: {
  clientId?: number;
  trainerId?: number;
  month?: string;
  limit?: number;
}) => {
  const q = new URLSearchParams();
  if (params.clientId) q.set("clientId", String(params.clientId));
  if (params.trainerId) q.set("trainerId", String(params.trainerId));
  if (params.month) q.set("month", params.month);
  if (params.limit) q.set("limit", String(params.limit));
  const qs = q.toString();
  return client.get<any>(`/bookings/cancellations${qs ? "?" + qs : ""}`);
};

const getCancellationsSummary = (month?: string) =>
  client.get<any>(
    `/bookings/cancellations/summary${month ? "?month=" + month : ""}`
  );

const getTrialClients = () => client.get<any>("/trial-clients");

const setTrialStatus = (id: number, status: string | null) =>
  client.post<any>(`/trial-clients/${id}/status`, { status });

const bookingApi = {
  getBookings,
  getBookingsForClients,
  book,
  cancel,
  trainerCancel,
  trainerBook,
  bookAll,
  cancelByClientId,
  setTrainer,
  getCancellations,
  getCancellationsSummary,
  getTrialClients,
  setTrialStatus,
};
export default bookingApi;
